module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy67srnvnlkvvvZb9+fb00rn67OPtton88+zonl3xxKL12cT55tn338/qpm0OnR6SAAAAu0lEQVR4Xu2Sy47DIBAEqRneD9v//7WbWOxpB1ZRlFvqhFRquoVwH+ZLTKqa4sJmD0CrdtZDHwGKqRMcD1F8Ma+/ULcB0nNat6szNAD8aekDaOPo4Bfax7nQ0BH6LElWvBGe+oRh6Q750XGBub16KAqU7ZuX6GziEJHsPkAdxy+yeNQJttaba6XnYaXlJsC/3a+n265baLu07LsV3aQjjE23QF3r7NHbyRnw5kebUQjuDyHNhaqlunf48gNLaAU/obYN3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_jun.png
// module id = 1690
// module chunks = 1